import React, { Component } from 'react';
import { Link } from 'react-router';

import OrganizationSelect from "../../components/OrganizationSelect";
import TerminalCom from "../../components/myTerminal"

import GatewayStore from "../../stores/GatewayStore";


class GatewayTerminal extends Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.state = {
      gateway: {},
    }
  }

  componentWillMount() {
    GatewayStore.getGateway(this.props.params.mac, (gateway) => {
      this.setState({
        gateway: gateway,
      });
    }); 
  }


  render() {
    const style = {
      height: "400px",
    };

    return(
      <div>
        <ol className="breadcrumb">
          <li><Link to="/organizations">Organizations</Link></li>
          <li><OrganizationSelect organizationID={this.props.params.organizationID} /></li>
          <li><Link to={`/organizations/${this.props.params.organizationID}/gateways`}>Gateways</Link></li>
          <li className="active">{this.state.gateway.name}</li>
        </ol>
        <hr />

        <div className="panel panel-default">
          <div className="panel-body">
            <TerminalCom mac={this.props.params.mac}/>
          </div>
        </div>
        
      </div>
    );
  }
}

export default GatewayTerminal;



// WEBPACK FOOTER //
// ./src/views/gateways/GatewayTerminal.js